import { APIRes } from "@/types/types"
import { parseAPIError } from "@/utils/parseAPIError"

import { SignIn } from "./signIn.interface"
import { User } from "@/schemas/User"
import { logger } from "@/utils/logger"

export const signIn: SignIn = async (request, input) => {
  try {
    logger.debug("[Action:Started] Sign in", input)
    const res = await request.post<APIRes<User>>("sign-in", { json: input }).json()
    logger.debug("[Action:Done] Sign in", input)
    return [res.data, null] as const
  } catch (_err) {
    logger.error("[Action:Error] Sign in", input)
    const error = await parseAPIError(_err)

    if (error.description === "Invalid email/password combination.")
      return [null, "INVALID_COMBINATION"]

    if (error.description === "Invalid reCAPTCHA (please refresh page)")
      return [null, "INVALID_RECAPTCHA"]

    if (error.description === "Invalid reCAPTCHA response (please refresh page).")
      return [null, "INVALID_RECAPTCHA"]

    if (error.description === "The account associated with this email has not yet been verified.")
      return [null, "ACCOUNT_NOT_VERIFIED"]
    return [null, "FALLBACK_ERROR"] as const
  }
}
